import React from 'react';
import { Settings as SettingsIcon } from 'lucide-react';

export default function SettingsPage() {
  const card = { background:'#1e293b', padding:16, borderRadius:8, border:'1px solid #334155' };
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
      <div style={card}>
        <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:12 }}>
          <SettingsIcon size={16} color="#94a3b8"/><h3 style={{ margin:0, fontSize:16, fontWeight:600 }}>Settings</h3>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 120px', gap:12, alignItems:'center' }}>
          <div style={{ color:'#e2e8f0' }}>Dark Theme</div>
          <div style={{ textAlign:'right', color:'#94a3b8' }}>(always on)</div>
          <div style={{ color:'#e2e8f0' }}>Quote TTL (seconds)</div>
          <input type="number" placeholder="5" style={{
            width:120, padding:8, background:'#334155', color:'#e2e8f0',
            border:'1px solid #475569', borderRadius:6, fontSize:13, justifySelf:'end'
          }}/>
          <div style={{ color:'#e2e8f0' }}>Auto Reconnect</div>
          <div style={{ textAlign:'right', color:'#10b981', fontWeight:600 }}>Enabled</div>
        </div>
      </div>
    </div>
  );
}
